import React from 'react'
import { ChooseTemplateIcon, AddTemplateIcon, AddedTemplateIcon } from '../../../components/common/SvgIcon'
import { Toast } from '../../../components/common/Toast'
import ProTemplates from './ProTemplates'
import AllShortCodes from './AllShortCodes'
import FormCard from '../../../components/common/FormCard'

const ChooseTemplate = ({ freeTemplates, proTemplates, isProActive, handleTemplateClick, loading, selectedTemplateId }) => {

  const getTemplateIcon = (templateName) => {
    const name = templateName.toLowerCase()
    
    if (name.includes('terms') || name.includes('tos')) {
      return '📄'
    } else if (name.includes('privacy')) {
      return '🔒'
    } else if (name.includes('cookie')) {
      return '🍪'
    } else if (name.includes('dmca')) {
      return '©'
    } else if (name.includes('california') || name.includes('ccpa')) {
      return '🏛️'
    } else {
      return '📋'
    }
  }

  const copyShortcode = (shortcode) => {
    const placeholder = `[${shortcode}]`
    
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(placeholder)
        .then(() => Toast.success('Shortcode copied!'))
        .catch(() => fallbackCopy(placeholder))
    } else {
      fallbackCopy(placeholder)
    }
  }

  const fallbackCopy = (text) => {
    const textArea = document.createElement('textarea')
    textArea.value = text
    textArea.style.position = 'fixed'
    textArea.style.left = '-999999px'
    document.body.appendChild(textArea)
    textArea.select()
    try {
      document.execCommand('copy')
      Toast.success('Shortcode copied!')
    } catch (err) {
      Toast.error('Failed to copy')
    }
    document.body.removeChild(textArea)
  }

  return (
    <div className="w-full space-y-4">
      <FormCard>
        <div className="lgb-content-title">
          <ChooseTemplateIcon />
          Choose a Template
        </div>
        
        {loading ? (
          <div className="space-y-3 mt-4">
            <div className="h-12 bg-gray-200 rounded-xl animate-pulse"></div>
            <div className="h-12 bg-gray-200 rounded-xl animate-pulse"></div>
            <div className="h-12 bg-gray-200 rounded-xl animate-pulse"></div>
          </div>
        ) : (
          <div className="mt-4">
            {/* Free Templates Section */}
            <div className="mb-6">
              <div className="bg-lgp-body">FREE TEMPLATES</div>
              <div className="mt-2 space-y-2 max-h-[300px] overflow-y-auto pr-2 custom-scrollbar">
                {freeTemplates.map((template) => {
                  const isSelected = selectedTemplateId === template.id
                  return (
                    <button
                      key={template.id}
                      onClick={() => handleTemplateClick(template.id, template.type)}
                      className={`w-full text-left px-3 py-3 rounded-xl transition flex items-center justify-between group cursor-pointer ${
                        isSelected 
                          ? 'bg-[#7C3BED] text-white shadow-md' 
                          : 'text-[#17171C] hover:bg-gray-50 border border-transparent hover:border-gray-200'
                      }`}
                    >
                      <div className="flex items-center gap-3">
                        <span className="text-xl">{getTemplateIcon(template.name)}</span>
                        <span className={`text-sm font-medium ${isSelected ? 'text-white' : 'text-[#17171C]'}`}>
                          {template.name}
                        </span>
                      </div>
                      <div className="transition-all duration-200">
                        {isSelected ? (
                          <AddedTemplateIcon />
                        ) : (
                          <AddTemplateIcon />
                        )}
                      </div>
                    </button>
                  )
                })}
              </div>
            </div>

            {/* Pro Templates Section */}
            <ProTemplates
              proTemplates={proTemplates}
              isProActive={isProActive}
              handleTemplateClick={handleTemplateClick}
              selectedTemplateId={selectedTemplateId}
              getTemplateIcon={getTemplateIcon}
            />
          </div>
        )}
      </FormCard>
    </div>
  )
}

export default ChooseTemplate